module.exports = __webpack_public_path__ + "img/back_25.dfdaea77.svg";